module.exports = __webpack_public_path__ + "img/ruou_vang_1.661deeee.jpg";